export default __webpack_public_path__ + "static/media/ag-icon.857df62d.svg";